import React from "react";
import { MyAccountAreaSectionWrapper } from "./myAccountAreaSectionWrapper";
import PropTypes from "prop-types";

const MyAccountAreaSection = props => {
  const { children, handleOnClick, dataTestId } = props;

  return (
    <MyAccountAreaSectionWrapper
      onClick={handleOnClick}
      data-testid={dataTestId}
    >
      {children}
    </MyAccountAreaSectionWrapper>
  );
};

MyAccountAreaSection.propTypes = {
  children: PropTypes.node,
  handleOnClick: PropTypes.func,
  dataTestId: PropTypes.string
};
export default React.memo(MyAccountAreaSection);
